import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryDiscount.js';
import { RichText, Image } from '@synergycms_core/components/generic';
import connect from 'react-redux/es/connect/connect';
import Price from '@synergycms_core/components/generic/Price';
import { withContent } from '@synergycms_core/components/providers/translateProvider';


const AvailMainSideSummaryDiscount = class AvailMainSideSummaryDiscount extends React.Component {
  static displayName = 'AvailMainSideSummaryDiscount';

  render() {
    const { config, theme, content } = this.props,
      {
        discountInfo,
        stepCode,
      } = config;

    const discounts = discountInfo;
    const totalDiscountAmount = discounts.reduce((sum, d) => sum + d.get('total_amount', 0), 0);

    const { classes } = theme.styles;

    return (
      <div className={classes.contentModule}>
        <div className={classes.contentModuleRow}>
          <div className={[classes.contentModuleCell, classes.large, classes.contentModuleCellTitle].join(' ')}>
            <RichText text={content.t('_%descuentos%_')} innerStyle={['uppercase']}/>
          </div>
          <div className={[classes.contentModuleCell, classes.contentModuleCellPrice].join(' ')}>
            <Price
              innerStyle={['summaryPriceSize15']}
              amount={totalDiscountAmount}
              forceHotelCurrency={stepCode === 'confirmation'}
            />
          </div>
        </div>

        {discounts.map(discount => (
          <div className={classes.contentModuleRow} key={discount.get('id')}>
            <div className={[classes.contentModuleCell, classes.large].join(' ')}>
              <div className={classes.discountContainer}>
                <Image svg={'checkCorpo'} innerStyle={[classes.discountIcon]}/>
                <RichText text={discount.get('name', '')} innerStyle={['roboto15Gray', classes.contentModuleCellDiscount]} />
              </div>
              <div className={classes.discountContainer}>
                <RichText text={discount.get('description', '')} innerStyle={['roboto13Gray',classes.contentModuleCellDescription]}/>
              </div>
            </div>
            <div className={[classes.contentModuleCell, classes.short, classes.contentModuleCellPrice].join(' ')}>
              <Price
                innerStyle={['roboto13Gray', classes.priceNumbers]}
                amount={discount.get('total_amount', 0)}
                forceHotelCurrency={stepCode === 'confirmation'}
              />
            </div>
          </div>
        ))}
      </div>

    )
  }

};

const mapStateToProps = (store, ownProps) => {

  return {
    stepCode: store.getIn(['customer', 'step', 'current_step', 'code']),
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, []),
  connect( mapStateToProps, ),
  PropertyManager([
    'discountInfo',
    'stepCode',
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryDiscount);
